import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'

// import { config } from './config';
import './semantic/dist/semantic.min.css'
import 'codemirror/theme/material-palenight.css'

// import Amplify from 'aws-amplify'
// Amplify.configure({
//   API: {
//     endpoints: [
//       {
//         name: 'API-Rows',
//         endpoint: 'https://z0en1nkupa.execute-api.us-east-1.amazonaws.com/development/'
//       }
//     ]
//   }
// })

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
